(function() {

  const excludedUrls = [
    "https://www.dartscorner.co.uk/products/designa-aluminium-shafts-metal-dart-stems-pink",
    "https://www.dartscorner.co.uk/products/designa-aluminium-shafts-metal-dart-stems-red",
    "https://www.dartscorner.co.uk/products/designa-aluminium-shafts-metal-dart-stems-gun-metal",
    "https://www.dartscorner.co.uk/products/designa-aluminium-shafts-metal-dart-stems-black",
    "https://www.dartscorner.co.uk/products/designa-aluminium-shafts-metal-dart-stems-blue",
    "https://www.dartscorner.co.uk/products/designa-aluminium-shafts-metal-dart-stems-gold",
    "https://www.dartscorner.co.uk/products/designa-aluminium-shafts-metal-dart-stems-green"
  ];

  if (excludedUrls.some(url => window.location.href.startsWith(url))) return;

  window.addEventListener("load", dartShafts);

  function dartShafts() {

    const btnCont = document.querySelectorAll('.option-selector__btns label');
    const shaftCont = document.querySelectorAll('.disclosure__content.rte.product-description div');

    const mmRegex = /(\d+(\.\d+)?)\s*mm/i;
    let mmSizes = [];

    shaftCont.forEach(el => {
      const match = el.textContent.match(mmRegex);
      if (match) mmSizes.push(parseFloat(match[1]));
    });

    if (mmSizes.length === 0) return;

    mmSizes = [...new Set(mmSizes)].sort((a, b) => a - b);

    btnCont.forEach((btn, index) => {
      const size = mmSizes[index];
      if (size && !btn.textContent.includes(`(${size}mm)`)) {
        btn.textContent += ` (${size}mm)`;
      }
    });
  }
})();
